import React, { useEffect, useState } from 'react';
import { SigningPages } from 'views/user-module/common/components/UI/SigningPages/SigningPages';
import SignInForm from 'views/common/components/Logical/Auth/SignInForm';
import { useTranslation } from 'next-i18next';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import PATHS from 'lib/navigation/paths';
import useSSONavigate from 'views/common/hooks/useSSONavigate';
import getQueryCSR from 'lib/utils/getQueryCSR';
import { useSelector } from 'react-redux';

const SignInView = () => {
  const { t } = useTranslation('fe_er_sign_up_page');
  const appNavigator = useAppNavigator();
  const appState = useSelector((state) => state.globalData.appState);
  const { moveToERSSOPage } = useSSONavigate();
  const [selectedTab, setSelectedTab] = useState(1);
  const handleTabClick = (e, value) => {
    switch (value) {
      case 2:
        setSelectedTab(value);
        appNavigator.push(PATHS.users.signUp(appNavigator.query));
        break;
      default:
        break;
    }
  };
  const handleRedirectToHomepage = (res) => {
    const query = getQueryCSR();
    moveToERSSOPage(
      res.access_token,
      query.return_url || window.location.origin,
    );
  };
  const handleSignUpBtnClick = () => {
    appNavigator.push(PATHS.users.signUp(appNavigator.query));
  };

  useEffect(() => {
    if (appState?.current_user) {
      appNavigator.push(PATHS.home());
    }
  }, []);

  return (
    <SigningPages
      title={t('fe_er_sign_up_page:sign_in')}
      handleTabClick={handleTabClick}
      selectedTab={selectedTab}
      hideWhyEagleriderSection>
      <SignInForm
        signUpLinkAction={handleSignUpBtnClick}
        redirectCallback={handleRedirectToHomepage}
      />
    </SigningPages>
  );
};

export { SignInView };
